import "../../styles/establishments/establishment-view.scss";
import "../../styles/establishment-only.scss";
require('intersection-observer');
import { bind_swiper } from "../integration/swiper";
import axios from "axios";
import { stringify } from "qs";
import { countdown } from "./components/countdown";
import { get_recommended_listings } from '../general/recommended-ajax-listings';
import { isEmpty } from "validate.js";

import lightGallery from 'lightgallery';
window.lightGallery = lightGallery;
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

import { initializeRatesGrid } from "../establishments/components/init-rates-grid";
import "../integration/leaflet/leaflet-wrapper";
import chevronLeftIcon from '../../images/icons/chevron-left.svg';
import chevronRightIcon from '../../images/icons/chevron-right.svg';
import chevronLeftGhostIcon from '../../images/icons/chevron-left-ghost.svg';
import chevronRightGhostIcon from '../../images/icons/chevron-right-ghost.svg';

import { checkOverflow } from "../general/read-more";
import { reloadEvents } from "../reviews/review-filter-sort-utilities";

const { site, is_mobile_device, mobile_os, page_name, leafletMap, is_app } = window.tg;

let closingByHistory = false;
window.addEventListener('popstate', function(e) {
    if (closingByHistory) {
        closingByHistory = false;
        return;
    }

    if (document.querySelector('.lg-visible')) {
        const closeBtn = document.querySelector('.lg-close');
        if (closeBtn) {
            closeBtn.click();
        }

        const allContainers = [
            document.getElementById('js-lightgallery-sixteen-by-nine'),
            document.getElementById('js-lightgallery-four-by-three'),
            ...document.querySelectorAll('[id^="js-lightgallery-room-"]')
        ].filter(Boolean);

        for (const container of allContainers) {
            if (container.lgInstance) {
                try {
                    container.lgInstance.closeGallery();
                } catch (e) {
                    // Continue if one fails
                }
            }
        }
        return;
    }

    if (document.querySelector('#js-modal.show')) {
        // Handle room modals and other bootstrap modals
        const modalCloseBtn = document.querySelector('#js-modal .close, #js-modal [data-dismiss="modal"]');
        if (modalCloseBtn) {
            modalCloseBtn.click();
        }
    }
});

const bsn = require('bootstrap.native');
const url = new URL(document.URL);
const uuid = url.searchParams.get("uuid");

/**
 *
 * GENERIC
 *
 */
// Retrieve threadID from header
const h1 = document.getElementsByTagName('h1')[0];
const estabId = h1 != undefined && h1.getAttribute('data-estab-id') !== null ? h1.getAttribute('data-estab-id') : '-1';
const customerId = h1 != undefined && h1.getAttribute('data-customer-id') !== null ? h1.getAttribute('data-customer-id') : '-1';
const tab = h1 != undefined ? h1.getAttribute('data-tab') : ""; // TODO

// Gather data for Map Modal
const mapAnchorList = document.querySelectorAll(".js-map-modal");
let latitude = '0'
let longitude = '0'
if (document.querySelector(".js-latitude") != null && document.querySelector(".js-longitude") != null) {
    latitude = document.querySelector(".js-latitude").textContent;
    longitude = document.querySelector(".js-longitude").textContent;
}

// Bind swiper to visible and invisible sliders
bind_swiper('.js-swiper-main');

if (document.querySelector(".js-swiper-sleeping-arrangements") !== null) {
    bind_swiper('.js-swiper-sleeping-arrangements');
}
if (document.querySelector(".js-swiper-room-arrangements") !== null) {
    bind_swiper('.js-swiper-room-arrangements');
}

// Initiate flash deal countdown if present
if (document.querySelector(".js-flash-deal") !== null) {
    countdown('.js-flash-deal');
}

if (document.querySelector(".js-flash-deal-mobile") !== null) {
    countdown('.js-flash-deal-mobile');
}

if (mapAnchorList && latitude && longitude) {
    mapAnchorList.forEach(mapAnchor => {
        mapAnchor.addEventListener('click', function () {
            mapModal(latitude, longitude);
        });
    })
}

// Switch read more on all bootsrap collapses
const collapseNodeListAnchors = /** @type {NodeListOf<HTMLAnchorElement>} */ (document.querySelectorAll("#feedback a[data-toggle='collapse']"));

if (collapseNodeListAnchors && collapseNodeListAnchors.length > 0) {
    collapseNodeListAnchors.forEach(anchor => {
        anchor.addEventListener('click', function () {
            if (anchor.getAttribute("aria-expanded") === "true") {
                anchor.innerHTML = anchor.dataset.more != null ? anchor.dataset.more : _t('kd.estab.read_more', 'Read more');
            } else {
                if (!anchor.classList.contains('description_more')) {
                    anchor.innerHTML = anchor.dataset.less != null ? anchor.dataset.less : _t('kd.estab.read_less', 'Read less');
                }
            }
        });
    });
}

const collapseNodeListAnchorsReviewMessage = /** @type {NodeListOf<HTMLAnchorElement>} */ (document.querySelectorAll("#review-message a[data-toggle='collapse']"));

if (collapseNodeListAnchorsReviewMessage && collapseNodeListAnchorsReviewMessage.length > 0) {
    collapseNodeListAnchorsReviewMessage.forEach(anchor => {
        anchor.addEventListener('click', function () {
            if (anchor.getAttribute("aria-expanded") === "true") {
                anchor.innerHTML = anchor.dataset.more != null ? anchor.dataset.more : _t('kd.estab.see_more', 'See more');
            } else {
                anchor.innerHTML = anchor.dataset.less != null ? anchor.dataset.less : _t('kd.estab.see_less', 'See less');
            }
        });
    });
}

const collapseNodeListAnchorsHostResponse = /** @type {NodeListOf<HTMLAnchorElement>} */ (document.querySelectorAll("#host-response a[data-toggle='collapse']"));

if (collapseNodeListAnchorsHostResponse && collapseNodeListAnchorsHostResponse.length > 0) {
    collapseNodeListAnchorsHostResponse.forEach(anchor => {
        anchor.addEventListener('click', function () {
            if (anchor.getAttribute("aria-expanded") === "true") {
                anchor.innerHTML = anchor.dataset.more != null ? anchor.dataset.more : _t('kd.estab.view_host_response', 'View host response');
            } else {
                anchor.innerHTML = anchor.dataset.less != null ? anchor.dataset.less : _t('kd.estab.hide_host_response', 'Hide host response');
            }
        });
    });
}

document.querySelectorAll("#translation-button").forEach(button => {
    button.addEventListener('click', function () {
        const reviewId = button.getAttribute("data");
        const englishReview = document.getElementById(`translated-review-${reviewId}`);
        const originalReview = document.getElementById(`original-review-${reviewId}`);
        const translationText = document.getElementById(`review-translation-${reviewId}`);

        if (englishReview && originalReview) {
            if (englishReview.classList.contains("d-none")) {
                englishReview.classList.remove("d-none");
                originalReview.classList.add("d-none");
                button.innerHTML = '<u>Show original</u>';
                translationText.textContent = 'This review has been automatically translated using Google.';
            } else {
                englishReview.classList.add("d-none");
                originalReview.classList.remove("d-none");
                button.innerHTML = '<u>Translate to English</u>';
                translationText.textContent = 'This review is displayed in its original language.';
            }
        }
    });
});

document.querySelectorAll("#host-response-translation-button").forEach(button => {
    button.addEventListener('click', function () {
        const reviewId = button.getAttribute("data");
        const englishResponse= document.getElementById(`translated-host-response-${reviewId}`);
        const originalResponse = document.getElementById(`original-host-response-${reviewId}`);
        const translationText = document.getElementById(`host-response-translation-${reviewId}`);

        if (englishResponse && originalResponse) {
            if (englishResponse.classList.contains("d-none")) {
                englishResponse.classList.remove("d-none");
                originalResponse.classList.add("d-none");
                button.innerHTML = '<u>Show original</u>';
                translationText.textContent = 'This review has been automatically translated using Google.';
            } else {
                englishResponse.classList.add("d-none");
                originalResponse.classList.remove("d-none");
                button.innerHTML = '<u>Translate to English</u>';
                translationText.textContent = 'This review is displayed in its original language.';
            }
        }
    });
});

/**
 *
 * Sticky Tabs
 *
 */
// Nav
const navFixed = /** @type {HTMLElement} */ (document.getElementById('js-nav-fixed'));
const navContainer = /** @type {HTMLElement} */ (document.getElementById('js-nav-container'));
const navRow = /** @type {HTMLElement} */ (document.getElementById('js-nav-row'));
const navCol = /** @type {HTMLElement} */ (document.getElementById('js-nav-col'));
const propertyTabs = /** @type {HTMLElement} */ (document.getElementById('property-tabs'));
const viewPageTabs = /** @type {HTMLElement} */ (document.getElementById('view-page-tabs'));
const navPriceboxFixed = /** @type {HTMLElement} */ (document.getElementById('js-navpricebox-fixed'));
const enquiryPage = document.querySelector('#enquiry-page') ? true : false;
const contentWrapper = document.querySelector('.col-12.col-lg-8');


// Nav Pricebox
const navPriceboxTransparent = /** @type {HTMLElement} */ (document.getElementById('js-navpricebox-transparent'));

// Language Overlay
const languageOverlay = document.getElementById('js-language-overlay');

const isNewViewPage = window.tg.ab_test_data.new_view_page == 'enabled';
if ('IntersectionObserver' in window && typeof is_mobile_device !== 'undefined' && is_mobile_device == false) {

    if (navContainer || propertyTabs) {
        const observerTabs = new IntersectionObserver((entries) => {

            entries.forEach(entry => {

                if (entry.target.id == 'js-title-box' && !enquiryPage) {
                    if (entry.isIntersecting) {
                        // Nav
                        if (window.innerWidth > 720) {
                            propertyTabs.classList.remove('nav-fixed');
                            propertyTabs.classList.remove('d-flex');
                            propertyTabs.classList.remove('align-items-start');
                            viewPageTabs.classList.remove('col-lg-8');
                            if (contentWrapper) {
                                contentWrapper.classList.remove('tabs-sticky-padding');
                            }
                        }
                        if (navPriceboxFixed) {
                            navPriceboxFixed.classList.remove('d-lg-block');
                            languageOverlay?.classList.remove('d-lg-none');
                        }
                    } else {
                        // IE specific ( entry.boundingClientRect.top )
                        if (entry.boundingClientRect.y < 0 || entry.boundingClientRect.top < 0) {
                            // Nav
                            if (window.innerWidth > 720) {
                                propertyTabs.classList.add('nav-fixed');
                                propertyTabs.classList.add('d-flex');
                                propertyTabs.classList.add('align-items-start');
                                propertyTabs.classList.remove('col-12');
                                viewPageTabs.classList.add('col-lg-8');
                                if (contentWrapper) {
                                    contentWrapper.classList.add('tabs-sticky-padding');
                                }
                            }

                            // Nav Pricebox
                            if (navPriceboxFixed) {
                                languageOverlay?.classList.add('d-lg-none');
                                navPriceboxFixed.classList.add('d-lg-block');
                                navPriceboxTransparent.style.height = "56px";
                                navPriceboxTransparent.classList.remove('invisible');
                            }
                        }
                    }
                } else if (entry.target.classList.contains('js-swiper-main')) {
                    if (entry.isIntersecting) {
                        if (navPriceboxFixed) {
                            navPriceboxFixed.classList.remove('d-lg-block');
                        }
                    }
                }
            })
        });

        if (document.getElementById('js-title-box')) {
            observerTabs.observe(document.getElementById('js-title-box'));
        }
        if (document.querySelector('.js-swiper-main')) {
            observerTabs.observe(document.querySelector('.js-swiper-main'));
        }
    }

    // Checks for hash and scrolls user down to relevant content
    if (url && url.hash === '#estabTabScroll') {
        const noHashURL = url.href.replace(/#.*$/, '');

        window.addEventListener("load", function () {
            if (navPriceboxFixed) {
                navPriceboxFixed.classList.remove('d-lg-none');
                navPriceboxFixed.classList.add('navpricebox-fixed');
            }
            window.history.replaceState('', document.title, noHashURL);
        })
    }
}


/**
 *
 *  Active nav items based on scroll position
 *  Data-targets affected: map, rooms, more-photos, rates
 *
 **/

const navbar = document.querySelector('#view-page-scroll-nav');


if (navbar) {
    const navItems = document.querySelectorAll('#js-nav-list .nav-link');
    const sections = document.querySelectorAll('section');

    // General observer config for all sections
    const observerConfig = {
        root: null,
        rootMargin: '0px',
        threshold: 0.7
    };

    // Custom observer configuration for the "rooms" section
    const roomsObserverConfig = {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
    };

    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const targetId = entry.target.getAttribute('id');
                setActiveNavItem(targetId);
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersection, observerConfig);
    const roomsObserver = new IntersectionObserver(handleIntersection, roomsObserverConfig);

    sections.forEach(section => {
        observer.observe(section);
    });

    const roomsSection = document.querySelector('#rooms');
    if (roomsSection) {
        roomsObserver.observe(roomsSection);
    }

    function setActiveNavItem(targetId) {
        navItems.forEach(navItem => {

            if (targetId == 'more-photos') {
                targetId = 'rooms';
            } else if (targetId == 'cancellation-policy' || targetId == 'house-rules' || targetId == 'we-are-viya') {
                targetId = 'rates';
            }

            const dataTarget = navItem.getAttribute('data-target');
            if (dataTarget === targetId) {
                navItem.classList.add('active', 'text-secondary', 'font-weight-bold');
            } else {
                navItem.classList.remove('active', 'text-secondary', 'font-weight-bold');
            }
        });
    }

    // Handle Query Params (from Enquiry Form)

    const tabQueryParam = (new URL(window.location.href)).searchParams.get('tab') || false; // tab_name || false

    const paramMap = {
        "reviews": "reviews",
        "location": "map",
        "rooms": "rooms",
        "rates": "rates",
    }

    document.addEventListener("DOMContentLoaded", () => {
        const targetButton = document.querySelector("[data-target='" + paramMap[tabQueryParam] + "']");
        if (targetButton) {
            targetButton.click();
        }
    }, { passive: true });
}

/**
 *
 * Map Modal Generate
 *
 * @param {string} latitude
 * @param {string} longitude
 */
function mapModal(latitude, longitude, options = {}) {

    let estab_modal = new bsn.default.Modal('#js-modal');

    // Modal areas
    let title = /** @type {HTMLElement} */ (document.querySelector('.modal-title'));
    let dialog = /** @type {HTMLElement} */ (document.querySelector('.modal-dialog'));
    let header = /** @type {HTMLElement} */ (document.querySelector('.modal-header'));
    let footer = /** @type {HTMLElement} */ (document.querySelector('.modal-footer'));
    let body = /** @type {HTMLElement} */ (document.querySelector('.modal-body'));

    // Change areas
    title.innerHTML = "";
    body.innerHTML = "";

    // Append js-map-canvas
    body.id = options.constructor === Object && Object.entries(options).length > 0 && options.identifier !== null && options.identifier !== '' ? options.identifier : 'js-map-canvas';
    body.classList.add('rounded');
    body.style.minHeight = '200px';

    // Append classes for maps full width
    dialog.classList.add('modal-full-map');
    // content.classList.add('h-min-100');

    // Unset max width given to modals in open-modal.js:109
    dialog.style.maxWidth = 'unset';

    // Move over header
    header.style.height = '0px';
    header.style.padding = '0px';
    header.style.border = '0px';

    let closeBtn = /** @type {HTMLElement} */ (header.children[1]);
    closeBtn.style.position = 'absolute';
    closeBtn.style.top = '1rem';
    closeBtn.style.right = '1rem';
    closeBtn.style.zIndex = '1020';
    closeBtn.style.backgroundColor = 'rgba(0, 0, 0, 0.75)';
    closeBtn.style.color = '#ffffff';

    // Create footer from pricebox
    let priceboxEl;
    let moneyBtn;

    if (document.querySelector('.js-pricebox-small') && document.querySelector('.js-make-a-booking')) {
        priceboxEl = /** @type {HTMLElement} */ (document.querySelector('.js-pricebox-small').cloneNode(true));
        moneyBtn = /** @type {HTMLElement} */ (document.querySelector('.js-make-a-booking').cloneNode(true));
    }

    if (typeof priceboxEl !== 'undefined' && typeof moneyBtn !== 'undefined' && footer.querySelector('.js-pricebox-map') == null) {
        const wrapper = document.createElement('div');
        const wrapperBtn = document.createElement('div'); // due to flex affecting anchor tag heights

        const estabTitle = document.createElement("h5");
        const newContent = document.createTextNode(h1.textContent);
        // add the text node to the newly created div
        estabTitle.appendChild(newContent);
        // moneyBtn.textContent = _t('kd.estab.book', 'Book');

        // Customize elements classes
        estabTitle.classList.add('w-100', 'text-truncate');
        moneyBtn.classList.remove('js-make-a-booking', 'w-100', 'mt-1', 'btn-sm');
        priceboxEl.classList.remove('js-pricebox-small');
        priceboxEl.classList.add('js-pricebox-map');
        wrapperBtn.classList.add('ml-auto', 'mt-0', 'ml-md-4');
        wrapper.classList.add('w-100', 'd-flex', 'flex-wrap', 'align-items-center');
        footer.classList.remove('d-none');
        footer.classList.add('py-1');

        // Append divs and elements
        wrapperBtn.append(moneyBtn);
        wrapper.append(estabTitle);

        wrapper.append(priceboxEl);
        wrapper.append(wrapperBtn);

        // Display the footer contents
        footer.append(wrapper);
    }

    // Disable right click on map
    body.addEventListener('contextmenu', e => {
        e.preventDefault();
    });

    // Display modal
    estab_modal.show();


    // Initiate or reset leafletMap
    setTimeout(function () {
        body.style.height = dialog.clientHeight - footer.clientHeight + 1 + 'px'; // IE catch all
        leafletMap.initialize([parseFloat(latitude), parseFloat(longitude)], { "identifier": body.id });

        // Disable dragging temporarily
        if (is_mobile_device && mobile_os === 'iOS') {
            leafletMap._map.dragging.disable();
        }

    }, 200);

    setTimeout(function () {
        leafletMap._map.dragging.enable();
    }, 1000)
}


/**
 *
 * Reset the modal for map tab
 *
 */
document.addEventListener('click', function (event) {
    const el = /** @type {HTMLTextAreaElement} */ (event.target);

    if (tab === 'map') {
        if (el.classList.contains('close') || el.id === 'js-modal') {
            const tabMap = document.getElementById('js-map-tab-canvas');
            tabMap.innerHTML = "";
            tabMap.className = "";

            setTimeout(function () {
                leafletMap.initialize([parseFloat(latitude), parseFloat(longitude)], { 'identifier': 'js-map-tab-canvas' });
            }, 100);
        }
    }
}, false);


let simulateClick = function (elem) {
    // Create our event (with options)
    var evt = document.createEvent('MouseEvent');
    evt.initMouseEvent(
        'click',
        true, /* bubble */
        true, /* cancelable */
        window, null,
        0, 0, 0, 0, /* coordinates */
        false, false, false, false, /* modifier keys */
        0,/*left*/
        null
    );
    elem.dispatchEvent(evt);
};


//Lightgallery Functions and Initiations
const lgMobile = document.getElementById('js-lightgallery-four-by-three');
initLightgalleryMobile(lgMobile)

// Main Swiper light gallery initiated
const lgDesktop = document.getElementById('js-lightgallery-sixteen-by-nine');
initLightgalleryDesktop(lgDesktop)


function setupLightgalleryGuard(lgElement, guardId) {
    if (!lgElement || !guardId || window[guardId]) {
        return;
    }
    window[guardId] = true;

    let isTransitioning = false;
    let openAt = 0;
    let iosBlocker = null;
    const isIOS = /iPad|iPhone/.test(navigator.userAgent);
    const isSafariOrChrome = /Safari|Chrome/.test(navigator.userAgent);

    function createIOSBlocker() {
        if (iosBlocker) return;
        iosBlocker = document.createElement('div');
        iosBlocker.style.cssText = `
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            z-index: 99999 !important;
            background: transparent !important;
            pointer-events: auto !important;
            touch-action: none !important;
        `;
        ['touchstart', 'touchmove', 'touchend', 'click', 'mousedown', 'mouseup'].forEach(eventType => {
            iosBlocker.addEventListener(eventType, function(e) {
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
            }, { capture: true, passive: false });
        });
        document.body.appendChild(iosBlocker);
    }

    function removeIOSBlocker() {
        if (iosBlocker && iosBlocker.parentNode) {
            iosBlocker.parentNode.removeChild(iosBlocker);
            iosBlocker = null;
        }
    }

    lgElement.addEventListener('lgBeforeOpen', function () {
        isTransitioning = true;
        openAt = Date.now();
        if (isIOS && isSafariOrChrome && !is_app) {
            createIOSBlocker();
            setTimeout(() => removeIOSBlocker(), 1000);
        }
    });

    lgElement.addEventListener('lgAfterOpen', function () {
        isTransitioning = false;
    });

    lgElement.addEventListener('lgBeforeClose', function () {
        isTransitioning = true;
        if (isIOS && isSafariOrChrome && !is_app) {
            removeIOSBlocker();
        }
    });

    lgElement.addEventListener('lgAfterClose', function () {
        isTransitioning = false;
        openAt = 0;
        if (isIOS && isSafariOrChrome && !is_app) {
            removeIOSBlocker();
        }
    });

    const guard = function (e) {
        if (isTransitioning) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        if (openAt > 0 && (Date.now() - openAt < 500)) {
            const target = e.target;
            const isControlElement = target.closest('.lg-close, .lg-prev, .lg-next, .lg-thumb-item, .lg-toggle-thumb');
            const isImageElement = target.tagName === 'IMG' || target.classList.contains('lg-object') || target.classList.contains('lg-image');

            if (!isControlElement && !isImageElement) {
                e.stopPropagation();
                e.preventDefault();
                return;
            }
        }
    };

    document.addEventListener('touchend', guard, {capture: true, passive: false});
    document.addEventListener('click', guard, {capture: true, passive: false});
}

function applyLightgalleryMobilePositioning() {
    if (!is_mobile_device) return;

    let headerHeight = 0;
    const mobileHeader = document.querySelector('.vy-header.establishment-state.mobile-header');
    if (mobileHeader) {
        headerHeight = mobileHeader.offsetHeight;
    }

    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

    const isIOS = /iPad|iPhone/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    let topSafeArea = 0;
    let bottomSafeArea = 0;

    if (is_app) {
        const lgOuter = document.querySelector('[id^="lg-outer-"]');
        if (lgOuter) {
            const lgOuterStyles = getComputedStyle(lgOuter);
            topSafeArea = parseInt(lgOuterStyles.marginTop) || 0;
            bottomSafeArea = parseInt(lgOuterStyles.paddingBottom) || 0;
        }

        if (topSafeArea === 0) {
            const bodyStyles = getComputedStyle(document.body);
            topSafeArea = parseInt(bodyStyles.paddingTop) || 0;
        }

        if (isAndroid && topSafeArea < 30) {
            topSafeArea = 30;
        }
    } else {
        if (isIOS) {
            const bottomSafeAreaValue = getComputedStyle(document.documentElement).getPropertyValue('env(safe-area-inset-bottom)');
            bottomSafeArea = parseInt(bottomSafeAreaValue) || 0;
        }
    }

    const lgInner = document.querySelector('.lg-inner');
    if (lgInner) {
        const innerHeight = is_app ? viewportHeight - topSafeArea : viewportHeight;
        const visualOffset = Math.round(innerHeight * 0.05);
        const calculatedPaddingBottom = bottomSafeArea + visualOffset;

        lgInner.style.paddingTop = is_app ? '0px' : `${headerHeight}px`;
        lgInner.style.paddingBottom = `${calculatedPaddingBottom}px`;
        lgInner.style.boxSizing = 'border-box';
        lgInner.style.display = 'flex';
        lgInner.style.alignItems = 'center';
        lgInner.style.justifyContent = 'center';
        lgInner.style.height = `${innerHeight}px`;

        setTimeout(() => {
            const lgPrev = document.querySelector('.lg-prev');
            const lgNext = document.querySelector('.lg-next');
            const paddingTop = is_app ? 0 : headerHeight;
            const translationY = (-topSafeArea + paddingTop - calculatedPaddingBottom) / 2;

            if (lgPrev) {
                lgPrev.style.transform = `translateY(${translationY}px)`;
            }
            if (lgNext) {
                lgNext.style.transform = `translateY(${translationY}px)`;
            }
        }, 50);
    }
}

function resetLightgalleryMobilePositioning() {
    if (!is_mobile_device) return;

    const lgInner = document.querySelector('.lg-inner');
    if (lgInner) {
        lgInner.style.paddingTop = '';
        lgInner.style.paddingBottom = '';
        lgInner.style.boxSizing = '';
        lgInner.style.display = '';
        lgInner.style.alignItems = '';
        lgInner.style.justifyContent = '';
        lgInner.style.height = '';
    }

    const lgPrev = document.querySelector('.lg-prev');
    const lgNext = document.querySelector('.lg-next');
    if (lgPrev) {
        lgPrev.style.transform = '';
    }
    if (lgNext) {
        lgNext.style.transform = '';
    }
}

function initLightgalleryMobile(lgMobile) {
    if (lgMobile !== undefined && lgMobile !== null) {
        const speed = 200;
        const lgInstance = lightGallery(lgMobile, {
            selector: '.js-lightgallery-item:not(.swiper-slide-duplicate)',
            download: false,
            enableDrag: false,
            zoomFromOrigin: false,
            startClass: '',
            speed: speed,
            mode: 'lg-fade',
            prevHtml: `<img src="${chevronLeftIcon}" alt="Previous" class="lg-nav-icon"/>`,
            nextHtml: `<img src="${chevronRightIcon}" alt="Next" class="lg-nav-icon"/>`,
            hideBarsDelay: 2147483647,
            thumbnail: false,
            toggleThumb: false,
            allowMediaOverlap: true,
            exThumbImage: 'data-src-thumb',
            mobileSettings: {
                controls: true,
            },
            licenseKey: '2A817ACD-5CE44491-98878891-437B3F14',
            supportLegacyBrowser: false,
            plugins: [lgZoom]
        });

        let originalBodyBg = '';

        lgMobile.addEventListener('lgAfterOpen', function () {
            applyLightgalleryMobilePositioning();
            history.pushState({ lg: 'open' }, 'Gallery');

            // Wait for lightGallery transition to complete before changing body background
            setTimeout(() => {
                originalBodyBg = document.body.style.backgroundColor;
                document.body.style.backgroundColor = '#000';
            }, 300);

            let meta = document.createElement('meta');
            meta.name = 'theme-color';
            meta.content = '#000000';
            meta.id = 'lg-theme-color';
            document.head.appendChild(meta);

        });

        lgMobile.addEventListener('lgBeforeClose', function () {
            document.body.style.backgroundColor = originalBodyBg;
            const meta = document.getElementById('lg-theme-color');
            if (meta) {
                document.head.removeChild(meta);
            }

            resetLightgalleryMobilePositioning();

            if (!closingByHistory) {
                if (history.state && history.state.lg === 'open') {
                    closingByHistory = true;
                    history.back();
                }
            }
        });

        lgMobile.lgInstance = lgInstance;

        setupLightgalleryGuard(lgMobile, '__lgMobileTapGuardInstalled');
    }
}

function initLightgalleryDesktop(lgDesktop) {
    if (lgDesktop !== undefined && lgDesktop !== null) {
        const speed = 200;
        const lgInstance = lightGallery(lgDesktop, {
            selector: '.js-lightgallery-item:not(.swiper-slide-duplicate)',
            download: false,
            enableDrag: false,
            startClass: '',
            speed: speed,
            mode: 'lg-fade',
            prevHtml: `<span class="lg-nav-icon-wrapper"><img src="${chevronLeftGhostIcon}" alt="Previous" class="lg-nav-icon lg-nav-icon-ghost"/><img src="${chevronLeftIcon}" alt="Previous" class="lg-nav-icon lg-nav-icon-filled"/></span>`,
            nextHtml: `<span class="lg-nav-icon-wrapper"><img src="${chevronRightGhostIcon}" alt="Next" class="lg-nav-icon lg-nav-icon-ghost"/><img src="${chevronRightIcon}" alt="Next" class="lg-nav-icon lg-nav-icon-filled"/></span>`,
            hideBarsDelay: 2147483647,
            thumbnail: false,
            toggleThumb: false,
            zoomFromOrigin: false,
            allowMediaOverlap: true,
            exThumbImage: 'data-src-thumb',
            mobileSettings: {
                controls: true,
            },
            licenseKey: '2A817ACD-5CE44491-98878891-437B3F14',
            supportLegacyBrowser: false,
            plugins: [lgThumbnail, lgZoom]
        });

        let originalBodyBg = '';

        lgDesktop.addEventListener('lgAfterOpen', function () {
            // Wait for lightGallery transition to complete before changing body background
            setTimeout(() => {
                originalBodyBg = document.body.style.backgroundColor;
                document.body.style.backgroundColor = '#000';
            }, 300);

            let meta = document.createElement('meta');
            meta.name = 'theme-color';
            meta.content = '#000000';
            meta.id = 'lg-theme-color';
            document.head.appendChild(meta);
            history.pushState({ lg: 'open' }, 'Gallery');
        });

        lgDesktop.addEventListener('lgBeforeClose', function () {
            document.body.style.backgroundColor = originalBodyBg;
            const meta = document.getElementById('lg-theme-color');
            if (meta) {
                document.head.removeChild(meta);
            }

            if (!closingByHistory) {
                if (history.state && history.state.lg === 'open') {
                    closingByHistory = true;
                    history.back();
                }
            }
        });
        lgDesktop.lgInstance = lgInstance;

        setupLightgalleryGuard(lgDesktop, '__lgDesktopTapGuardInstalled');
    }
}

// Preload images fucntion
function preloadImage(img) {
    const src = img.getAttribute('data-src');
    if (!src) {
        return;
    }
    img.src = src;
}

/**
 *
 * TAB SPECIFIC LOGIC
 *
 */

// Sidebar gallery initiates main sliders lightgallery at specified slide based on data-image-id
if (tab !== 'post-enquiry') {
    document.addEventListener('click', function (event) {
        const el = /** @type {HTMLTextAreaElement} */ (event.target);
        // Hack to enable duplicates to function as they are not bound with lighgallery on purpose
        if (el.classList.contains('swiper-lazy') && el.parentElement.classList.contains('swiper-slide-duplicate')) {
            if (el.parentElement.getAttribute('data-swiper-slide-index') !== null) {
                const imageIndex = parseInt(el.parentElement.getAttribute('data-swiper-slide-index')) + 1;
                let roomOrMainSwiper = el.classList.contains('js-room');
                let swiperWrapper = el.closest(".swiper-wrapper");
                if (swiperWrapper) {
                    let galleryItemClass = roomOrMainSwiper ? '.js-lightgallery-room-item' : '.js-lightgallery-item';
                    let lgItems = swiperWrapper.querySelectorAll(galleryItemClass);

                    if (lgItems[imageIndex]) {
                        simulateClick(lgItems[imageIndex]);
                    }
                }
            }
        } else if (el.matches('.js-sidebar-gallery-image, .js-swiper-gallery-image, .js-grid-gallery-image')) {
            const imageIndex = el.getAttribute('data-image-id');
            let lgItems = document.querySelectorAll('#js-lightgallery-sixteen-by-nine .js-lightgallery-item');
            // In case js-lightgallery-sixteen-by-nine is not present, check if js-lightgallery-four-by-three is present
            if (lgItems.length < 1 || lgItems === null || lgItems === undefined) {

                lgItems = document.querySelectorAll('#js-lightgallery-four-by-three .js-lightgallery-item');
            }
            // Do not allow to click if there isn't anything
            if (lgItems.length > 0 && lgItems !== null && lgItems !== undefined) {
                simulateClick(lgItems[imageIndex]);
            }
        } else if (el.classList.contains('view-gallery-btn')) { // Click on View Gallery goes straight to lightgallery
            let lgItems = document.querySelectorAll('#js-lightgallery-sixteen-by-nine .js-lightgallery-item');
            // In case js-lightgallery-sixteen-by-nine is not present, check if js-lightgallery-four-by-three is present
            if (lgItems.length < 1 || lgItems === null || lgItems === undefined) {

                lgItems = document.querySelectorAll('#js-lightgallery-four-by-three .js-lightgallery-item');
            }

            // Do not allow to click if there isn't anything
            if (lgItems.length > 0 && lgItems !== null && lgItems !== undefined) {
                simulateClick(lgItems[0]);
            }
        }
    }, false);

    // Lazy load Sidebar
    const images = document.querySelectorAll('.image-lazy');
    const config = {
        rootMargin: '0px 0px 100px 0px', // increase 100px to auto load images earlier out of viewport
        threshold: 0
    };

    let observer = new IntersectionObserver(function (entries, self) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                preloadImage(entry.target);
                // Stop watching and load the image
                self.unobserve(entry.target);
            }
        });
    }, config);

    images.forEach(image => {
        observer.observe(image);
    });
}
// End Sidebar gallery initiates main sliders lightgallery at specified slide based on data-image-id
if (tab === 'overview') {
    const descriptionMore = document.getElementById('description_more');
    const descriptionMoreAnchor = document.querySelector('.description_more');

    // Bind swiper to room arrangements if unit type
    if (document.querySelector(".js-swiper-sleeping-arrangements") !== null) {
        bind_swiper('.js-swiper-sleeping-arrangements');
    }

    if (descriptionMoreAnchor && descriptionMore && descriptionMore.clientHeight > 70) {
        descriptionMore.classList.add('collapse', 'mb-2');
        descriptionMore.classList.remove('mb-0');
        descriptionMoreAnchor.classList.remove('d-none');
    }

    descriptionMoreAnchor.addEventListener('click', function (event) {
        if (descriptionMoreAnchor.text.trim() === _t('kd.estab.read_more', 'Read more')) {
            descriptionMoreAnchor.text = _t('kd.estab.read_less', 'Read less');
        } else {
            descriptionMoreAnchor.text = _t('kd.estab.read_more', 'Read more');
        }
    });


}

// set bathroom icon for room-arrangments cards
if (tab == 'overview' || tab == 'rooms') {
    const bathroomConfigRows = document.querySelectorAll('.bathroom-config');

        bathroomConfigRows.forEach(row => {
            const pTag = row.querySelector('p');
            const svgIcon = row.querySelector('svg');

            if (!svgIcon || !pTag) {
                return;
            }

            const text = pTag.textContent.trim();
            let iconName = 'shower'; // default
            if (['Toilet', 'Toilet with bidet', 'Toilet met bidet'].includes(text)) {
                iconName = 'toilet';
            } else if (/^(Bath|Spa|Shower fixed over bath|Bad|Stort-oor-bad)/.test(text)) {
                iconName = 'bath';
            } else if (text.startsWith("Shower") || text.startsWith("Stort")) {
                iconName = 'shower';
            }

            svgIcon.setAttribute('data-icon', iconName);
        });

       //rerender only once after icon updates
        if (window.FontAwesome?.dom?.watch) {
            window.FontAwesome.dom.watch();
        }
}

// Show and hide additional property rooms in room-arrangements snippet
if (tab == 'overview') {

    const showHideButton = document.getElementById('show-hide-units')
    const roomCards = document.querySelectorAll('.room-card')
    const roomMask = document.getElementById('room-mask')

    // variable to determine whether the function will show or hide rooms
    let showOrHide = 'show';

    function showhideRooms() {
        // loop through roomCards and check display properties
        // if display: none, remove and add display: flex

        if (showOrHide === 'show'){
            roomCards.forEach(card => {
                if (card.classList.contains('d-none')) {
                    card.classList.add('shown')
                    card.classList.remove('d-none')
                }
            });
            roomMask.classList.add('d-none');
            showHideButton.innerHTML = _t('tl.estab.hide_rooms','Hide rooms');
            showOrHide = 'hide'
        }

        else if (showOrHide === 'hide') {
            roomCards.forEach(card => {
                if (card.classList.contains('shown')) {
                    card.classList.add('d-none');
                    card.classList.remove('shown');
                }
            });
            roomMask.classList.remove('d-none');
            showHideButton.innerHTML = _t('tl.estab.view_all_rooms','view all rooms')
            showOrHide = 'show'
        }


    }
    if (showHideButton) {
        showHideButton.addEventListener('click', showhideRooms)
    }
}

// If Room is selected in reviews tab, redirect to this tab and simulate a click to open the room
if (tab === 'rooms') {
    document.addEventListener('DOMContentLoaded', function() {
        const urlParams = new URLSearchParams(window.location.search);
        const roomId = urlParams.get('roomId');
        if (roomId) {
            const elementToClick = document.querySelector(`a[data-room-id="${roomId}"]`);
            if (elementToClick) {
                elementToClick.click();
                urlParams.delete('roomId');
                const searchParamsString = urlParams.toString();
                const newUrl = window.location.pathname + (searchParamsString ? '?' + searchParamsString : '') + window.location.hash;
                history.pushState({}, '', newUrl);
            }
        }
    });
}

if (tab === 'rooms' || site == 'vy') {
    if (site != 'vy') {
        bind_swiper('.js-swiper-room');
    }

    const roomMoreAnchors = document.querySelectorAll('.js-room-more');
    if (roomMoreAnchors.length > 0) {
        roomMoreAnchors.forEach(anchor => {
            initRoomMoreContent(anchor)
        })
    }

    document.addEventListener('click', function (event) {
        const el = /** @type {HTMLElement} */ (event.target);

        if (el.classList.contains('js-room-gallery-image')) {
            const roomImageID = el.getAttribute('data-image-id');
            const roomID = el.getAttribute('data-room-id');
            let lgItems = document.getElementById('js-lightgallery-room-' + roomID).querySelectorAll('.js-lightgallery-room-item');
            simulateClick(lgItems[roomImageID]);
        }
    }, false);
}

function initRoomMoreContent(anchor) {
    let roomID = anchor.getAttribute("data-room-id");

    if (site != 'vy') {
        // Bind LightGallery to each room swiper
        let lgRoom = document.getElementById('js-lightgallery-room-' + roomID);
        initLightgalleryRoom(lgRoom)
    }

    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        let roomName = anchor.getAttribute("data-room-name");
        const roomContent = (document.getElementById('js-room-more-content-' + roomID)).cloneNode(true);

        if (roomContent !== null) {
            let body
            if (site != 'vy') {
                const roomModal = new bsn.default.Modal('#js-modal');
                const title = document.querySelector('.modal-title');
                body = document.querySelector('.modal-body');
                const dialog = /** @type {HTMLElement} */ (document.querySelector('.modal-dialog'));
                const footer = /** @type {HTMLElement} */ (document.querySelector('.modal-footer'));

                title.id = "unit-modal-title";

                body.innerHTML = "";
                body.classList.add("unit-modal-body");

                dialog.style.maxWidth = '800px';

                roomContent.classList.remove('d-none');

                const roomLazyImage = roomContent.querySelectorAll('.room-image-lazy');
                roomLazyImage.forEach(entry => {
                    preloadImage(entry);
                });

                title.innerHTML = roomName;
                body.append(roomContent);

                // Add `Close` button for the modal
                footer.classList.remove("d-none");
                let footerContent = `
                    <div class="btn-container">
                        <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-primary text-decoration-none">
                            ${_t('kd.estab.hostprofile.close', 'Close')}
                        </button>
                    </div>
                `;

                // Add `Book` button if there's availability
                const roomBookHref = anchor.getAttribute("data-room-href");
                if (roomBookHref && roomBookHref !== '') {
                    const roomBookText = anchor.getAttribute("data-book-cta");
                    footerContent += `
                        <div class="btn-container">
                            <a
                                href="${roomBookHref}"
                                class="btn btn-primary text-decoration-none"
                                title="${roomBookText}"
                                alt="${roomBookText}">
                                    ${roomBookText}
                            </a>
                        </div>
                    `;
                }
                footer.innerHTML = footerContent;

                roomModal.show();

                if (mobile_os === 'Android' || mobile_os === 'iOS') {
                    setTimeout(() => {
                        history.pushState({ roomModal: 'open' }, 'Room Details');
                    }, 100);

                    const modalElement = document.getElementById('js-modal');
                    const handleModalClose = () => {
                        if (!closingByHistory && history.state && history.state.roomModal === 'open') {
                            closingByHistory = true;
                            history.back();
                        }
                        modalElement.removeEventListener('hidden.bs.modal', handleModalClose);
                    };
                    modalElement.addEventListener('hidden.bs.modal', handleModalClose);
                }

                // Bind swiper to room arrangements if unit type
                setTimeout(() => {
                    if (document.querySelector("#js-modal .js-swiper-sleeping-arrangements") !== null) {
                        bind_swiper('.js-swiper-sleeping-arrangements');
                    }
                }, 200);
            } else {
                const roomTray = document.querySelector('#js-bottom-tray')
                const roomDetailsBody = roomContent.querySelector('.body').innerHTML
                const roomDetailsFooter = roomContent.querySelector('.footer').innerHTML

                roomTray.querySelector('.tray-content-wrapper').innerHTML = roomDetailsBody
                roomTray.querySelector('.tray-footer .custom-footer').innerHTML = roomDetailsFooter

                body = roomTray.querySelector('.tray-body');
            }

            const roomGrid = body.querySelector('.grid-' + roomID);

            if (roomGrid !== null) {
                roomGrid.setAttribute('id', 'grid-' + roomID);
                setTimeout(() => {
                    initializeRatesGrid('#grid-' + roomID, true, roomID)
                }, 300)
            }
        }
    });
}

function initLightgalleryRoom(lgRoom) {
    if (lgRoom !== undefined && lgRoom !== null) {
        const speed = 200;
        const lgInstance = lightGallery(lgRoom, {
            selector: '.js-lightgallery-room-item:not(.swiper-slide-duplicate)',
            download: false,
            enableDrag: false,
            startClass: '',
            speed: speed,
            mode: 'lg-fade',
            prevHtml: is_mobile_device ? `<img src="${chevronLeftIcon}" alt="Previous" class="lg-nav-icon"/>` : `<span class="lg-nav-icon-wrapper"><img src="${chevronLeftGhostIcon}" alt="Previous" class="lg-nav-icon lg-nav-icon-ghost"/><img src="${chevronLeftIcon}" alt="Previous" class="lg-nav-icon lg-nav-icon-filled"/></span>`,
            nextHtml: is_mobile_device ? `<img src="${chevronRightIcon}" alt="Next" class="lg-nav-icon"/>` : `<span class="lg-nav-icon-wrapper"><img src="${chevronRightGhostIcon}" alt="Next" class="lg-nav-icon lg-nav-icon-ghost"/><img src="${chevronRightIcon}" alt="Next" class="lg-nav-icon lg-nav-icon-filled"/></span>`,
            hideBarsDelay: 2147483647,
            allowMediaOverlap: true,
            exThumbImage: 'data-src-thumb',
            mobileSettings: {
                controls: true,
            },
            licenseKey: '2A817ACD-5CE44491-98878891-437B3F14',
            supportLegacyBrowser: false
        });

        let originalBodyBg = '';

        lgRoom.addEventListener('lgAfterOpen', function () {
            applyLightgalleryMobilePositioning();
            setTimeout(() => {
                originalBodyBg = document.body.style.backgroundColor;
                document.body.style.backgroundColor = '#000';
            }, 300);
            history.pushState({ lg: 'open' }, 'Gallery');
        });

        lgRoom.addEventListener('lgBeforeClose', function () {
            document.body.style.backgroundColor = originalBodyBg;
            resetLightgalleryMobilePositioning();

            if (!closingByHistory) {
                if (history.state && history.state.lg === 'open') {
                    closingByHistory = true;
                    history.back();
                }
            }
        });

        lgRoom.lgInstance = lgInstance;

        setupLightgalleryGuard(lgRoom, `__lgRoomTapGuard_${lgRoom.id}`);
    }
}

if (tab === 'map') {
    leafletMap.initialize([parseFloat(latitude), parseFloat(longitude)], { 'identifier': 'js-map-tab-canvas' });
}

if ('rates' in window && site != 'vy' && tab != 'rooms') {
    initializeRatesGrid()

    /**
     * For LekkeSlaap & Travelground only, on Rates tab toggle the pensioner special from the Pensioner Special banner.
     */

    const pensionerSpecialCheckbox = /** @type {HTMLInputElement} */ (document.getElementById('pensioner_specials_checkbox'));
    if (pensionerSpecialCheckbox) {
        pensionerSpecialCheckbox.addEventListener('click', (e) => {
            e.preventDefault();
            const url = '/backend/accommodation/toggle_pensioner_session';

            axios({
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                method: 'post',
                url: url,
                data: stringify({
                    'pensioner_session': pensionerSpecialCheckbox.checked === true ? 1 : 0
                })
            }).then(() => {
                window.location.reload();
              });
        });
    }

}

if (tab === 'post-enquiry') {
    const newsletterCheckbox = /** @type {HTMLInputElement} */ (document.getElementById('js-newsletter-subscribe'));

    if (newsletterCheckbox !== null) {
        const email = newsletterCheckbox.getAttribute('data-customer-email');

        if (email !== '' && email !== null) {
            newsletterCheckbox.addEventListener('click', function () {
                const url = newsletterCheckbox.checked === false ? '/backend/accommodation/add_unsubscribed_email' : '/backend/accommodation/remove_unsubscribed_email'

                axios({
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    method: 'post',
                    url: url,
                    data: stringify({
                        'email': email
                    })
                });
            });
        }
    }
}

if (tab == 'reviews') {
    // Review switch from translated to original, vice versa
    document.addEventListener('click', function (event) {
        const el = /** @type {HTMLTextAreaElement} */ (event.target);
        if (el.classList.contains('js-switch-review')) {
            event.preventDefault();
            let translatedReviewEls = document.querySelectorAll('#original-lang-review-switch');
            translatedReviewEls.forEach(el => {
                const reviewID = el.dataset.id;
                if (reviewID !== null) {
                    const customerReviewEl = document.querySelector('.js-customer-language-review-' + reviewID);
                    const translatedReviewEl = document.querySelector('.js-original-review-' + reviewID);

                    if (customerReviewEl != null && translatedReviewEl != null) {
                        if (customerReviewEl.classList.contains('d-none')) {
                            customerReviewEl.classList.remove('d-none');
                            translatedReviewEl.classList.add('d-none');
                        } else {
                            customerReviewEl.classList.add('d-none');
                            translatedReviewEl.classList.remove('d-none');
                        }
                    }
                }
            });
        }
    }, false);

    // Set the position of the `Back to top` button inline with the 'Make a Booking' section
    window.addEventListener('DOMContentLoaded', adjustBackToTop);
    window.addEventListener('resize', adjustBackToTop);

    function adjustBackToTop() {
        const jsBackToTop = document.querySelector('#js-back-to-top');
        const makeABookingParent = document.querySelector('.card-body.p-0');
        const makeABookingParentMobile = document.querySelector('.js-hide-when-search-open.position-sticky.sticky-bottom');

        if (!is_mobile_device) {
            if (jsBackToTop && makeABookingParent) {
                const makeABookingParentRect = makeABookingParent.getBoundingClientRect();
                jsBackToTop.style.left = `${makeABookingParentRect.right - jsBackToTop.offsetWidth}px`;
            } else {
                console.error('Required elements for JS back to top not found in the DOM.');
            }
        } else if (jsBackToTop && makeABookingParentMobile) {
            jsBackToTop.style.bottom = makeABookingParentMobile.clientHeight + 16 + 'px'
        } else {
            console.error('Required elements for JS back to top not found in the DOM.');
        }
    }
}

/**
 *
 * SOCIAL VIEW PAGE LOGIC
 *
 */

// Mutation observer used to check when tray opens to initialize certain content
if (site == 'vy') {
    const tray = document.getElementById('js-bottom-tray')

    const observer = new MutationObserver(function (mutations) {
        if (Alpine.store('general').tray.openTray == 'establishment-rooms') {
            // Initialize room "read more" links and content
            const newElements = tray.querySelectorAll('.js-room-more')

            if (newElements.length > 0) {
                newElements.forEach(function (newElement) {
                    initRoomMoreContent(newElement)
                });
            }
        } else if (Alpine.store('general').tray.openTray == 'room-details') {
            const unitId = Alpine.store('general').tray.itemId;
            setTimeout(() => {
                let lgRoom = tray.querySelector(`#js-lightgallery-room-${unitId}`)
                initLightgalleryRoom(lgRoom)

                // Mobile room tray - view more photos
                const roomPhotoGridWrapper = tray.querySelector('.js-room-photos-grid-wrapper')
                const seeMoreButton = tray.querySelector('.js-see-more-room-photos')

                if (roomPhotoGridWrapper && seeMoreButton) {
                    seeMoreButton.addEventListener('click', (event) => {
                        event.preventDefault();
                        roomPhotoGridWrapper.style.maxHeight = 'unset';
                        roomPhotoGridWrapper.style.marginBottom = '0';
                        seeMoreButton.classList.add('d-none');
                    })

                    let roomPhotosOverflowing = checkOverflow(roomPhotoGridWrapper.querySelector('.photos-grid'))
                    if (!roomPhotosOverflowing) {
                        seeMoreButton.classList.add('d-none')
                        roomPhotoGridWrapper.style.marginBottom = '0';
                    }
                }
            }, 200)
        }
    });

    observer.observe(tray, { attributes: true });
}

// Sticky nav and pricebox
const scrollTabs = document.getElementById('js-scroll-tabs')
const navWrapper = document.getElementById('view-page-scroll-nav')
const mobileHeader = document.querySelector('.vy-header.establishment-state.mobile-header')
const desktopHeader = document.querySelector('.vy-header.general-desktop-state')
const mainPricebox = document.getElementById('js-main-pricebox')
const isDesktop = typeof is_mobile_device !== 'undefined' && is_mobile_device == false
if (mobileHeader != null && scrollTabs != null) {

    let headerHeight = mobileHeader.offsetHeight
    if (isDesktop) {
        headerHeight = desktopHeader.offsetHeight // wave height
    }

    let scrollTabLinks = scrollTabs.querySelectorAll('.nav-link')

    scrollTabLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            const el = /** @type {HTMLTextAreaElement} */ (event.target);

            let target = el.dataset.target
            let targetSection = document.querySelector(`.view-page-section-wrapper#${target}`)
            let scrollOffset = headerHeight

            if (!scrollTabs.classList.contains('view-sticky-header-item')) {
                // Add extra space for tabs when scrolling from top of page since they leave
                // the dom when becoming sticky which makes the scroll position incorrect
                scrollOffset = scrollOffset + scrollTabs.offsetHeight
            }

            let targetPosition = targetSection.getBoundingClientRect();

            window.scrollTo({
                top: targetPosition.top + window.scrollY - scrollOffset - 47,
                left: targetPosition.left,
                behavior: 'smooth'
            });
        }, false);
    });



    if ('IntersectionObserver' in window) {
        const scrollObserver = new IntersectionObserver((entries) => {

            entries.forEach(entry => {
                if (entry.target.id == 'js-desktop-header-end' || entry.target.id == 'js-mobile-header-end') {
                    if (entry.isIntersecting) {
                        if (isDesktop) {
                            navWrapper.classList.remove('container-xl')

                            navPriceboxFixed.classList.add('d-none')
                            navPriceboxTransparent.classList.add('invisible')

                            // Add shadow back to main pricebox
                            mainPricebox.classList.add('show-shadow')
                        } else {
                            mobileHeader.classList.add('position-absolute')
                            mobileHeader.classList.add('bg-transparent')
                            mobileHeader.classList.remove('view-sticky-header-item')
                        }

                        scrollTabs.classList.add('d-none')
                        scrollTabs.classList.remove('view-sticky-header-item')
                        scrollTabs.style.top = 'unset'
                    } else {
                        if (isDesktop) {

                            // Disable sticky pricebox if search is open
                            if (window.Alpine.store('general').openSection == 'SEARCH') {
                                return
                            }

                            navWrapper.classList.add('container-xl')

                            // Set sticky pricebox to same width as static pricebox
                            navPriceboxFixed.style.width = `${mainPricebox.offsetWidth}px`

                            navPriceboxFixed.style.top = `${headerHeight + scrollTabs.offsetHeight}px`
                            navPriceboxTransparent.classList.remove('invisible');
                            navPriceboxFixed.classList.remove('d-none')

                            // Remove shadow from main pricebox so that it doesn't show behind the sticky one
                            mainPricebox.classList.remove('show-shadow')
                        } else {
                            mobileHeader.classList.remove('position-absolute')
                            mobileHeader.classList.remove('bg-transparent')
                            mobileHeader.classList.add('view-sticky-header-item')
                        }

                        scrollTabs.classList.remove('d-none')
                        scrollTabs.classList.add('view-sticky-header-item')
                        scrollTabs.style.top = `${headerHeight}px`
                    }
                }
            })
        });

        if (document.getElementById('js-desktop-header-end')) {
            scrollObserver.observe(document.getElementById('js-desktop-header-end'));
        } else {
            scrollObserver.observe(document.getElementById('js-mobile-header-end'));
        }
    }

}

/**
 *
 * Log / Analytics
 *
 */
let logs = {}

if (navigator.cookieEnabled) {
    logs = JSON.parse(window.localStorage.getItem('logs-results-click'));

    setTimeout(() => {
        if (uuid !== null) {
            const url = new URL(document.URL);
            let path = url.pathname;

            window.history.replaceState({ location: path }, document.title, removeParam('uuid', url.href));
            //  Check localStorage if establishment exist
            updateLogResultClick();
        }
    }, 100);
}

function updateLogResultClick() {
    if (uuid !== null && page_name === 'establishment.overview'
        && !isEmpty(logs)
        && !isEmpty(logs[uuid])
        && !isEmpty(logs[uuid].establishments)
        && !isEmpty(logs[uuid].establishments[estabId])) {

        // Create log instance from logs
        let general = logs[uuid].general
        let establishment = logs[uuid].establishments[estabId]

        // Merge properties of viewed establishment and general log properties
        let log = {}
        Object.assign(log, general, establishment)

        if (isEmpty(log)) {
            return;
        }

        if (parseInt(log.log_id) == 0) {
            axios({
                method: "post",
                url: `/backend/results/log`,
                data: log,
            })
                .then(function (response) {
                    if (response.data.success) {
                        // Update localeStorage logs with new log information for establishment so we do not log it again
                        logs[uuid].establishments[estabId].log_id = parseInt(response.data.data.id)
                        logs[uuid].establishments[estabId].click_time = response.data.data.click_time;

                        window.localStorage.setItem('logs-results-click', JSON.stringify(logs));
                    } else {
                        throw `ERROR: Log entry not created for estabId: ${estabId} with uuid: ${uuid}`
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    return false;
                })
        }
    }
}

function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

window.toggleReview = (id) => {
    const textBlock = document.querySelector(`#review-${id} .review-body`);
    textBlock.classList.toggle('line-clamp-3');

    const readMoreBtn = document.querySelector(`#review-${id} .read-more`);

    const readMoreText = readMoreBtn.querySelector('.more');
    readMoreText.classList.toggle('d-none');

    const readLessText = readMoreBtn.querySelector('.less');
    readLessText.classList.toggle('d-none');
}

// Resize SVG on Host Profile Card
function resizeHostProfileCardSVG() {
    const hostProfileCard = document.getElementById("host-profile-card");
    const largeViewport = window.innerWidth >= 768;

    const ownerName = document.getElementById("#owner-name");
    const textWrapsMoreThanTwice = ownerName ? ownerName.clientHeight > 48 : false;

    if (largeViewport && textWrapsMoreThanTwice) {
        hostProfileCard.style.backgroundPositionX = "-72px";
    }
}

site === "ls" && window.addEventListener("load", () => {
    resizeHostProfileCardSVG();
}, { passive: true });

site === "ls" && window.addEventListener("resize", () => {
    resizeHostProfileCardSVG();
}, { passive: true });

// Load images into Host Overview Swiper Cards

function removeLoadingIndicators(el) {
    const loadingItems = el.querySelectorAll('.loading-item');
    for (let item of loadingItems) {
        item.classList.remove('loading-item');
    }
}

const modal = document.getElementById('js-modal')

site === "ls" && modal.addEventListener('shown.bs.modal', function() {
    let cards = document.querySelectorAll('#host-profile-modal .swiper-slide');
    for (let i = 0; i < cards.length; i++) {
        const card = cards[i];

        const target = card.querySelector("#property-img-container")
        const src = card.dataset.src;
        const name = card.dataset.name;

        const image = new Image();
        image.id = "host-profile-property-img";
        image.className = "img-fluid";
        image.src = src;
        image.alt = name;

        image.onload = () => {
            target.appendChild(image);
            removeLoadingIndicators(card);
        }
    }
})

//Initialise Recent Reviews Swiper
let swiperInitialized = false;

const swiperConfig = {
    spaceBetween: 0,
    loop: false,
    slidesPerView: is_mobile_device ? 1.2 : 2.2,
    centeredSlides: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    grabCursor: false,
    watchSlidesProgress: true,
    passiveListeners: true,
    shortSwipes: is_mobile_device,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
};

const unitsSwiperConfig = {
    spaceBetween: 8,
    loop: false,
    slidesPerView: is_mobile_device ? 1.5 : 3.2,
}

if (!swiperInitialized) {
    new Swiper(".recent-reviews-swiper", Object.assign(swiperConfig));
    new Swiper(".js-swiper-peek", Object.assign(unitsSwiperConfig));
    swiperInitialized = true;
}

let property_id = "";
const reviews_filter_sort_div = document.querySelector(
    "#reviews_filter_sort_div"
);

if (reviews_filter_sort_div) {
    property_id = reviews_filter_sort_div.getAttribute("data-eid");
}

function addLoadMoreEventListener(property_id_param) {
    const loadMoreButton = document.getElementById('load-more-reviews');
    if (!loadMoreButton) return; // Exit if button not found

    loadMoreButton.addEventListener('click', function() {
        toggleLoader("show", "#loader-container-show-more");
        const existingReviewIDs = Array.from(document.querySelectorAll('#review-snippet-parent [data-eid]')).map(element => element.getAttribute('data-eid'));
        axios({
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            method: "post",
            url: "/backend/accommodation/get_more_reviews",
            data: stringify({
                property_id: property_id_param,
                current_review_ids: existingReviewIDs,
            }),
        })
            .then((response) => {
                return response;
            })
            .then((output) => {

                if (output.data && output.data.success) {
                    const html = output.data.data.html;

                    // Replace the reviews container with the new HTML
                    let reviews_container =
                        document.querySelector("#reviews-container");
                    let parentElement = reviews_container.parentNode;
                    let newDiv = document.createElement("div");
                    newDiv.innerHTML = html;
                    parentElement.replaceChild(newDiv, reviews_container);
                    reviews_container = newDiv;

                    // Re-add the event listener after updating the content
                    addLoadMoreEventListener(property_id);
                    reloadEvents();
                }
            })
            .catch((error) => {
                toggleLoader("hide", "#loader-container-show-more");
            });
    });
}

function toggleLoader(action, ID) {
    const loaderContainer = document.querySelector(ID);
    if (action === 'show') {
        loaderContainer.classList.remove("d-none");
    } else if (action === 'hide') {
        loaderContainer.classList.add("d-none");
    }
}

// Initial call to add the event listener
addLoadMoreEventListener(property_id);

/* Don't storage history when clicking on
the tabs this allows the back button to
always go back to the overview page */
if (window.tg.page_name !== 'establishment.overview') {
    document.querySelectorAll('.nav-link, .navigation-link').forEach((el) => {
        el.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default link navigation
            const newPage = this.getAttribute('href');
            window.location.replace(newPage); // Replace the current URL with the new one without adding to the history
        });
    });
}
